import { Injectable } from '@angular/core';
import { MatDateFormats, NativeDateAdapter } from '@angular/material/core';

@Injectable({
  providedIn: 'root'
})

export class AppDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      const day = date.getDate();
      const month = date.toLocaleString('default', { month: 'short' });
      const year = date.getFullYear();

      return `${this._twoDigit(day)}-${month}-${year}`;
    }
     else {
      const month = date.toLocaleString('default', { month: 'short' });
      const year = date.getFullYear();
      let result = month +  ' ' + year
      return result
    }
  }

  private _twoDigit(n: number) {
    return ('00' + n).slice(-2);
  }
}

export const APP_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};

export class CustomCalenderService {

  constructor() { }
}
